import { inject, Injectable } from '@angular/core';
import { GetRewardsProgramPreference } from '@features/rewards-program/store/actions/rewards-program-preference.actions';
import { UserInit } from '@features/user-init/user-init.actions';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { BroadCastListener } from '@rd/broadcast/store/action';
import { BroadcastListeners } from '@rd/broadcast/types';
import { filter, map, tap } from 'rxjs/operators';

@Injectable()
export class RootEffects {
  constructor(private actions$: Actions) {}

  unleashService = inject(UnleashService);

  reloadOnGetRewardsProgramPreference$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(BroadCastListener),
        filter(() => false),
        filter(
          ({ listener }) =>
            listener === BroadcastListeners.REWARDS_PROGRAM_PREFERENCE_LISTENER,
        ),
        tap(() => {
          window.location.reload();
        }),
      ),
    {
      dispatch: false,
    },
  );

  loadRewardsProgramPreferenceOnUserInit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserInit),
      filter(() => false),
      map(() => GetRewardsProgramPreference()),
    ),
  );
}
